import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { GazetteerSearchResult } from "./gazetteer-search.model";
import { environment } from "./../../../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class GazetteerSearchService {
  constructor(private http: HttpClient) {}

  /**
   * Gazetteer search
   * @param  {string} searchTerm
   * @param  {number} page
   * @returns Observable
   */
  search(searchTerm: string, page: number): Observable<GazetteerSearchResult> {
    return this.http.get<GazetteerSearchResult>(
      `${environment.apiBaseURL}/gazetteer/european-gazetteer/${searchTerm}/${page}`
    );
  }
}
